// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1IvvQ","info":"UpdateTermsInfo_info__cbKCH"};